import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    makeStyles
} from '@material-ui/core';
import { DeleteExpense } from '../../../store/actions/vehicleActionCreator';
import * as logger from '../../../logger';
import { getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';
import { deleteOfficeExpense } from "../../../store/actions/expensesActionCreators";
import { sendError,sendSucces } from "../../../utils/utils";
const useStyles = makeStyles((theme) => ({
    divV1: {
        fontWeight: 'bold', fontSize: '16px'
    },
    mtV1: {
        marginTop: '8px'
    },
    capitalizeV1: {
        textTransform: "capitalize"
    },
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
}));

const DeleteOfficeExpenseDialog = ({ open, onClose, dispatchDeleteExpense, expenseParentType, expenseId, onConfirm }) => {
    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onDeleteExpense = () => {
        dispatchDeleteExpense(expenseId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Expense Dialog", "Delete Expense Successfull");
                    sendSucces("Office Expense Deleted SucessFully")
                    onConfirm();
                    setDialogOpen(false);
                }
            },
            () => {
                logger.log("Delete Expense Dialog", "Delete Expense Failed");
            }
        )
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Delete <span className={classes.capitalizeV1}>{expenseParentType == "other" ? "Driver/Other" : expenseParentType}</span> Expense</div>
                    <div className={classes.mtV1}>Do you want to delete office expense entry</div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDeleteExpense}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )

}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteExpense: (expenseId, onSuccess, onFailure) => dispatch(deleteOfficeExpense(expenseId, onSuccess, onFailure)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteOfficeExpenseDialog);